const state = {

  UserItems: {
    data: [],
    paginator: 1,
    currentPage: 1,
    limit: 100,
    total: 0
  },
  Loadings : {
    list : false
  }
};

const getters = {
  ListingUser: (state) => state.UserItems,
  Loadings : (state) => state.Loadings,
};

const actions = {

  async getListUser({commit}, params) {
    commit( 'setLoadings', {key:"list",val:true});
    return new Promise((resolve, reject) => {
      global.axios(`/api/users`, {
        method: "GET",
        params: {
          limit  : params.limit || 50,
          page   : params.page || 1,
          filter : params.filters
        },
        headers: {
            Accept: "application/json",
        }
      })
      .then(response => {
        let data = {
          items: response.data.data.items,
          total: response.data.data.total,
          currentPage: params.page,
          limit: params.limit || 50,
          filter: params.filters
        }
        commit( 'setLoadings', {key:"list",val:false});
        commit('setListingUser',data)
        resolve(data.data.data);
      })
      .catch(error => reject( error ));
    

    });
  },
  async searchListUser({commit}, params) {
    commit( 'setLoadings', {key:"list",val:true});
    return new Promise((resolve, reject) => {
      global.axios(`/api/users`, {
        method: "GET",
        params: {
          limit  : params.limit || 50,
          page   : params.page || 1,
          filter : params.filters
        },
        headers: {
            Accept: "application/json",
        }
      })
      .then(response => {
        let data = {
          data: response.data.data.items,
          total: response.data.data.total,
          currentPage: params.page,
          limit: params.limit || 50,
          filter: params.filters
        }
        commit( 'setLoadings', {key:"list",val:false});
        resolve(data);
      })
      .catch(error => reject( error ));
    

    });
  },
  async SaveUser({commit}, params) {
    commit( 'setLoadings', {key:"list",val:true});
    return new Promise((resolve, reject) => {
      global.axios(`/api/users`, {
        method: "POST",
        data: params,
        headers: {
            Accept: "application/json",
        }
      })
      .then(response => {
          commit( 'setLoadings', {key:"list",val:false});
          commit( 'updateListingUser', response.data.data );
          resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async updateUser({commit}, params) {
    commit( 'setLoadings', {key:"list",val:true});
    return new Promise((resolve, reject) => {
      global.axios(`/api/users/${params.id}`, {
        method: "PUT",
        data: params,
        headers: {
            Accept: "application/json",
        }
      })
      .then(response => {
          commit( 'setLoadings', {key:"list",val:false});
          commit( 'editListingUser', response.data.data );
          resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
  async deleteUser({commit}, params) {
    commit( 'setLoadings', {key:"list",val:true});
    return new Promise((resolve, reject) => {
      global.axios(`/api/users`, {
        method: "DELETE",
        data:  {
          ids : params
        },
        headers: {
            Accept: "application/json",
        }
      })
      .then(response => {
          commit( 'setLoadings', {key:"list",val:false});
          resolve( response );
      })
      .catch(error => reject( error ));
    });
  },

};

const mutations = {
  setListingUser (state,items) {
    state.UserItems = {
        data        : items.items,
        paginator   : Math.ceil(items.total / items.limit),
        currentPage : items.currentPage,
        limit       : items.limit,
        total       : items.total,
        filter      : items.filter
    };
  },
  updateListingUser (state,user) {
    state.UserItems.data = [...state.UserItems.data,user];
  },
  editListingUser (state,user) {
    if(state.UserItems.data) {
      state.UserItems.data = state.UserItems.data.map(item => item.id === user.id ? user : item)
    }
  },
  setLoadings (state,data) {
    if(data.key === "list"){
        state.Loadings.list = data.val;
    }
},
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}